import React from 'react';
import { IIcon } from '../../interfaces/IIcon';
import { Icon } from '../Icon';

export function AirplaneIcon(props: IIcon) {
    const viewBox = props.viewBox || '0 0 19 19';
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={viewBox}
            style={props.style}
            className={props.className}
        >
            <path d="M18.299 0.0463588L16.2883 0.961503C16.1595 1.02093 16.0407 1.10214 15.9397 1.20316L12.6632 4.48144L1.37977 3.12853C1.17573 3.10476 0.969714 3.17409 0.825105 3.32067L0.197148 3.9486C-0.13565 4.28138 -0.0326411 4.84393 0.397222 5.03607L8.48341 8.661L6.16175 10.9825H2.10677C1.92849 10.9825 1.75813 11.0538 1.63135 11.1786L1.29261 11.5193C0.955847 11.8561 1.06678 12.4246 1.50259 12.6108L4.92367 14.0766L6.38956 17.4975C6.57577 17.9333 7.14628 18.0442 7.48108 17.7075L7.82178 17.3668C7.94856 17.24 8.01789 17.0696 8.01789 16.8914V12.8366L10.3396 10.5151L13.9647 18.6028C14.1568 19.0326 14.7194 19.1356 15.0522 18.8029L15.6801 18.175C15.8267 18.0284 15.8961 17.8243 15.8723 17.6203L14.5173 6.3375L17.7958 3.05922C17.8968 2.9582 17.978 2.84133 18.0375 2.7106L18.9527 0.700053C19.1448 0.28604 18.7169 -0.143801 18.299 0.0463588Z" />
        </Icon>
    );
}
